/**
 * Bloque de preguntas frecuentes visible. Mismo patrón editorial que el FAQ
 * del catálogo (regla horizontal, pregunta a la izquierda, respuesta a la
 * derecha), sin la animación `reveal-on-scroll`: ese bloque nace oculto y
 * depende de un observador; aquí el texto tiene que estar siempre pintado,
 * porque es justo el que lee el prerenderizador y el rastreador.
 *
 * Las preguntas son <h3>: la página que lo use pone el <h2> de la sección.
 */
export default function FaqSection({ eyebrow = 'Antes de comprar', heading, items, testId = 'faq-section', className = '' }) {
    if (!items?.length) return null;
    return (
        <section className={className} data-testid={testId}>
            <p className="eyebrow mb-4">{eyebrow}</p>
            <h2 className="font-heading text-2xl md:text-3xl font-black mb-8 text-balance" style={{ color: 'var(--ink)' }}>
                {heading}
            </h2>
            <div className="border-t" style={{ borderColor: 'var(--line)' }}>
                {items.map(({ q, a }) => (
                    <div
                        key={q}
                        className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-10 py-6 border-b"
                        style={{ borderColor: 'var(--line)' }}
                    >
                        <h3 className="md:col-span-4 font-heading text-base md:text-lg font-bold" style={{ color: 'var(--ink)' }}>
                            {q}
                        </h3>
                        <p className="md:col-span-8 text-[15px] leading-relaxed text-pretty" style={{ color: 'var(--ink-soft)' }}>
                            {a}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
